import React from 'react';
import { Box } from '@mui/material';
import type { RoleplayStatus } from '../types';

import bgImage from '../../../assets/images/bg_room_02.png';
import yourTurnIcon from '../../../assets/images/ic_your_turn_1.svg';

export interface RoleplayVisualAreaProps {
  avatarImage: string;
  status: RoleplayStatus;
  isSmallScreen: boolean;
}

export const RoleplayVisualArea: React.FC<RoleplayVisualAreaProps> = ({
  avatarImage,
  status,
  isSmallScreen,
}) => (
  <Box sx={{
    width: '100%',
    height: '100%',
    aspectRatio: '16/7',
    position: 'relative',
    overflow: 'hidden',
    bgcolor: '#e6eef7',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  }}>
    <Box
      component="img"
      src={bgImage}
      alt="背景"
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
      }}
    />
    <Box sx={{
      position: 'absolute',
      left: '50%',
      bottom: 0,
      transform: 'translateX(-50%)',
      zIndex: 2,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      height: '100%',
      width: 'auto',
      overflow: 'hidden',
    }}>
      <Box
        component="img"
        src={avatarImage}
        alt="アバター"
        sx={{
          height: '120%',
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'cover',
        }}
      />
    </Box>
    {status !== 'aiSpeaking' && status !== 'processing' && status !== 'waiting' && (
      isSmallScreen ? (
        <Box
          component="img"
          src={yourTurnIcon}
          sx={{
            position: 'absolute',
            top: '18px',
            left: '18px',
            bgcolor: 'rgba(212,0,0,0.7)',
            color: '#fff',
            padding: '8px',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 400,
            zIndex: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      ) : (
        <Box sx={{
          position: 'absolute',
          top: '18px',
          left: '18px',
          bgcolor: 'rgba(212,0,0,0.7)',
          color: '#fff',
          padding: '8px 28px',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 400,
          zIndex: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          あなたのターン
        </Box>
      )
    )}
  </Box>
);
